import { render, staticRenderFns } from "./looktwo.vue?vue&type=template&id=a21b098e"
import script from "./looktwo.vue?vue&type=script&lang=js"
export * from "./looktwo.vue?vue&type=script&lang=js"
import style0 from "./looktwo.vue?vue&type=style&index=0&id=a21b098e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports